import React, { Component } from "react";
import { BrowserRouter as Redirect } from "react-router-dom";
import Header from "../../Header";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import $ from "jquery";
import "bootstrap-daterangepicker/daterangepicker.css";
// import DateRangePicker from "react-bootstrap-daterangepicker";
import DatePicker from "react-datepicker";
import moment, { duration } from "moment";

import HCExporting from "highcharts/modules/exporting";
import HCVariwide from "highcharts/modules/variwide";

import highcharts3d from "highcharts/highcharts-3d";
import Funnel from "highcharts/modules/funnel";
import HighchartsMap from "highcharts/modules/map";

//World map customization start
import SelectPicker from "rsuite/SelectPicker";
import DateRangePicker from "rsuite/DateRangePicker";
import "rsuite/CheckPicker/styles/index.css";
import "../../assets/css/rsuite.css";
import { addDays } from "date-fns";

const predefinedRanges = [
  {
    label: "Today",
    value: [new Date(), new Date()],
    placement: "left",
  },
  {
    label: "Yesterday",
    value: [addDays(new Date(), -1), addDays(new Date(), -1)],
    placement: "left",
  },
  {
    label: "Last 7 Days",
    value: [addDays(new Date(), -7), new Date()],
    placement: "left",
  },
  {
    label: "Last 30 Days",
    value: [addDays(new Date(), -30), new Date()],
    placement: "left",
  },
];

const dealStates = [
  { label: "Website Traffic", value: "activeUsers" },
  { label: "Lead", value: "lead" },
  { label: "Customer", value: "customer" },
].map((item) => ({ label: item.label, value: item.value }));

//World map customization End

highcharts3d(Highcharts);
HighchartsMap(Highcharts);

// Initialize the modules
HCExporting(Highcharts);
HCVariwide(Highcharts);
Funnel(Highcharts);

class Newanalytics extends Component {
  constructor() {
    super();
    var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
    var localdata = has_local_data
      ? this.decrypt(localStorage.getItem("encdata"), 0)
      : "";
    var dt = new Date(),
      y = dt.getFullYear(),
      m = dt.getMonth() + 1,
      d = dt.getDate();
    var end_dt = `${y}-${m}-${d}`;
    var en_date = new Date(`${y}-${m}-1`);
    var currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 5);

    var formattedDate =
      currentDate.getFullYear() +
      "-" +
      String(currentDate.getMonth() + 1).padStart(2, "0");

    this.state = {
      apiUrl: this.decryptconfigdata("apiUrl"),
      userAuthKey: has_local_data ? localdata.user_key : "",
      fields: {},
      errors: {},
      revenue_pie: [],
      product_pie: [],
      lead_chart: [],
      customer_chart: [],
      revenue_chart: [],
      category: [],
      total_customers: "",
      total_leads: "",
      total_cancelled: "",
      total_revenue: "",
      from_date: moment().startOf("month").format("YYYY-MM-DD"),
      to_date: new Date(end_dt),
      start: moment().startOf("month"),
      end: moment(),
      startDate: new Date(formattedDate),
      endDate: en_date,
      start_year_month: formattedDate,
      end_year_month: `${y}-${m}`,
      minDate: en_date,
      user_type: "activeUsers",
      traffic_cache: 1,
      lead_toggle: "true",
      customer_toggle: "true",
      revenue_toggle: "true",
      canellation_toggle: "true",
      //new world map customization
      newStartDate: formattedDate + "-01",
      newEndDate: end_dt,
      newSelDate: [new Date(formattedDate + "-01"), en_date],
    };

    this.getRevenuePieChart = this.getRevenuePieChart.bind(this);
    this.getProductPieChart = this.getProductPieChart.bind(this);
    // this.getLeadChart = this.getLeadChart.bind(this);
    this.productDashboard = this.productDashboard.bind(this);
    this.datePickerChange = this.datePickerChange.bind(this);
    this.getCustomerChart = this.getCustomerChart.bind(this);
    this.getRevenueChart = this.getRevenueChart.bind(this);
    this.getTrendFunnel = this.getTrendFunnel.bind(this);
    this.getTrafficChart = this.getTrafficChart.bind(this);
    this.getCountryData = this.getCountryData.bind(this);
    this.getCancelledChart = this.getCancelledChart.bind(this);
    this.getLeadPieChart = this.getLeadPieChart.bind(this);
    this.getCancelledPieChart = this.getCancelledPieChart.bind(this);
  }

  decryptconfigdata(configkey) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;
  }

  decrypt(findresponse, flg) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  }

  componentDidMount() {
    document.title = "Intranet | Analytics";
    if (!localStorage.getItem("userLogin")) {
      this.setState({ redirect: true });
    }
    this.setState(
      (state) => {
        return {
          ...state,
          from_date: new Date().getFullYear() + "-" + 1,
          to_date: new Date(),
        };
      },
      () => {
        this.productDashboard();
      }
    );
  }

  productDashboard() {
    $(".loader-new").removeClass("hidden");
    $(".full-analytics").addClass("hidden");
    $(".graph").addClass("hidden");
    const filter_params = {
      start_date: this.state.startDate,
      end_date: this.state.to_date,
    };
    fetch(process.env.REACT_APP_CRM + `/analytics/get-data`, {
      method: "POST",
      dataType: "json",
      body: JSON.stringify(filter_params),
    })
      .then((Response) => Response.json())
      .then((responseJson) => {
        $(".loader-new").addClass("hidden");
        this.setState({
          total_customers: responseJson.total_customers,
          total_leads: responseJson.total_leads,
          total_cancelled: responseJson.total_cancelled,
          total_revenue: responseJson.total_revenue,
          category: responseJson.category,
        });

        $(".full-analytics").removeClass("hidden");
        $(".graph").removeClass("hidden");

        this.getTrendFunnel();
        this.getTrafficChart();
        this.getCountryData();
        this.state.lead_toggle ? this.getLeadChart() : this.getLeadPieChart();
        this.state.customer_toggle
          ? this.getCustomerChart()
          : this.getProductPieChart();
        this.state.revenue_toggle
          ? this.getRevenueChart()
          : this.getRevenuePieChart();
        this.state.canellation_toggle
          ? this.getCancelledChart()
          : this.getCancelledPieChart();
      });
  }

  getRevenueChart() {
    Highcharts.getJSON(
      process.env.REACT_APP_CRM +
      `/analytics/get-monthly-line-chart?start_date=${this.state.start_year_month}&end_date=${this.state.end_year_month}&type=revenue`,
      function (data) {
        Highcharts.chart("revenue_base_chart", {
          chart: {
            type: "line",
            height: 250,
          },
          exporting: {
            buttons: {
              contextButton: {
                enabled: false,
              },
            },
          },
          title: {
            text: " ",
            align: "left",
          },

          subtitle: {
            text: "",
            align: "left",
          },

          yAxis: {
            title: {
              text: "",
            },
            gridLineColor: "#ffffff",
            lineColor: "#ffffff",
          },

          xAxis: {
            title: {
              text: data.last_updated,
            },
            type: "datetime",
            dateTimeLabelFormats: {
              day: "%e %b", // format for days
            },
          },
          tooltip: {
            formatter: function () {
              var point = this.point;
              var series = point.series;
              var index = point.index;

              // Check if there is a previous point
              if (index > 0) {
                var prevPoint = series.data[index - 1];
                if (prevPoint.y !== 0 && Math.abs(prevPoint.y) > 0.000001) {
                  var percentageChange =
                    ((point.y - prevPoint.y) / prevPoint.y) * 100;
                  if (isFinite(percentageChange)) {
                    return (
                      // series.name +
                      // "<br>" +
                      Highcharts.dateFormat("%b", point.x) +
                      ": $" +
                      point.y +
                      " (" +
                      percentageChange.toFixed(2) +
                      "%)"
                    );
                  } else {
                    return (
                      // series.name +
                      // "<br>" +
                      Highcharts.dateFormat("%b", point.x) +
                      ": $" +
                      point.y +
                      " (Infinity)"
                    );
                  }
                } else if (prevPoint.y === 0) {
                  return (
                    // series.name +
                    // "<br>" +
                    Highcharts.dateFormat("%b", point.x) +
                    ": $" +
                    point.y +
                    " (0.00%)"
                  );
                } else {
                  return (
                    // series.name +
                    // "<br>" +
                    Highcharts.dateFormat("%b", point.x) +
                    ": $" +
                    point.y +
                    " (NaN)"
                  );
                }
              }

              // If there is no previous point, only display the value
              return (
                // series.name +
                // "<br>" +
                Highcharts.dateFormat("%b", point.x) +
                ": $" +
                point.y
              );
            },
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
            layout: "horizontal",
            align: "center",
            verticalAlign: "bottom",
            itemStyle: {
              font: "7pt Trebuchet MS, Verdana, sans-serif",
            },
            symbolWidth: 7,
            symbolHeight: 7,
            symbolRadius: 2,
          },

          plotOptions: {
            series: {
              label: {
                connectorAllowed: false,
              },
              pointIntervalUnit: "month",
            },
          },

          series: data.response,
        });
      }
    );
  }

  getRevenuePieChart() {
    Highcharts.getJSON(
      process.env.REACT_APP_CRM +
      `/analytics/get-monthly-pie-chart?start_date=${this.state.start_year_month}&end_date=${this.state.end_year_month}&type=pie_revenue`,
      function (data) {
        Highcharts.chart("revenue_pie_chart", {
          chart: {
            type: "pie",
            options3d: {
              enabled: true,
              alpha: 45,
            },
            height: 250,
            // width: 500
          },
          exporting: {
            buttons: {
              contextButton: {
                enabled: false,
              },
            },
          },
          title: {
            text: data.last_updated,
            align: "center",
            verticalAlign: "bottom",
            y: 10,
            style: {
              fontSize: "12 px",
              color: "rgb(102, 102, 102)",
            },
          },
          subtitle: {
            text: "",
            align: "left",
          },

          credits: {
            enabled: false,
          },
          tooltip: {
            pointFormat: "<b>{point.percentage:.1f}% (${point.y})</b>",
          },

          plotOptions: {
            pie: {
              depth: 20,
            },
            series: {
              dataLabels: {
                format: "<b>{point.name} ({point.percentage:.1f}%)",
              },
            },
          },
          series: data.response,
        });
      }
    );
  }

  getProductPieChart() {
    Highcharts.getJSON(
      process.env.REACT_APP_CRM +
      `/analytics/get-monthly-pie-chart?start_date=${this.state.start_year_month}&end_date=${this.state.end_year_month}&type=pie_product`,
      function (data) {
        Highcharts.chart("product_pie_chart", {
          chart: {
            type: "pie",
            options3d: {
              enabled: true,
              alpha: 45,
            },
            height: 250,
            // width: 500
          },
          exporting: {
            buttons: {
              contextButton: {
                enabled: false,
              },
            },
          },
          title: {
            text: data.last_updated,
            align: "center",
            verticalAlign: "bottom",
            y: 10,
            style: {
              fontSize: "12 px",
              color: "rgb(102, 102, 102)",
            },
          },

          subtitle: {
            text: "",
            align: "left",
          },
          credits: {
            enabled: false,
          },
          tooltip: {
            pointFormat: "<b>{point.percentage:.1f}% ({point.y})</b>",
          },
          plotOptions: {
            pie: {
              depth: 20,
            },
            series: {
              dataLabels: {
                format: "<b>{point.name} ({point.percentage:.1f}%)",
              },
            },
          },
          series: data.response,
        });
      }
    );
  }

  getLeadChart() {
    Highcharts.getJSON(
      process.env.REACT_APP_CRM +
      `/analytics/get-monthly-line-chart?start_date=${this.state.start_year_month}&end_date=${this.state.end_year_month}&type=leads`,
      function (data) {
        Highcharts.chart("lead_chart", {
          chart: {
            type: "line",
            height: 250,
          },
          exporting: {
            buttons: {
              contextButton: {
                enabled: false,
              },
            },
          },
          title: {
            text: " ",
            align: "left",
          },

          subtitle: {
            text: "",
            align: "left",
          },

          yAxis: {
            title: {
              text: "",
            },
            gridLineColor: "#ffffff",
            lineColor: "#ffffff",
          },

          xAxis: {
            title: {
              text: data.last_updated,
            },
            type: "datetime",
            dateTimeLabelFormats: {
              day: "%e %b", // format for days
            },
          },
          tooltip: {
            formatter: function () {
              var point = this.point;
              var series = point.series;
              var index = point.index;

              // Check if there is a previous point
              if (index > 0) {
                var prevPoint = series.data[index - 1];
                if (prevPoint.y !== 0 && Math.abs(prevPoint.y) > 0.000001) {
                  var percentageChange =
                    ((point.y - prevPoint.y) / prevPoint.y) * 100;
                  if (isFinite(percentageChange)) {
                    return (
                      // series.name +
                      // "<br>" +
                      Highcharts.dateFormat("%b", point.x) +
                      ": " +
                      point.y +
                      " (" +
                      percentageChange.toFixed(2) +
                      "%)"
                    );
                  } else {
                    return (
                      // series.name +
                      // "<br>" +
                      Highcharts.dateFormat("%b", point.x) +
                      ": " +
                      point.y +
                      " (Infinity)"
                    );
                  }
                } else if (prevPoint.y === 0) {
                  return (
                    // series.name +
                    // "<br>" +
                    Highcharts.dateFormat("%b", point.x) +
                    ": " +
                    point.y +
                    " (0.00%)"
                  );
                } else {
                  return (
                    // series.name +
                    // "<br>" +
                    Highcharts.dateFormat("%b", point.x) +
                    ": " +
                    point.y +
                    " (NaN)"
                  );
                }
              }

              // If there is no previous point, only display the value
              return (
                // series.name +
                // "<br>" +
                Highcharts.dateFormat("%b", point.x) +
                ": " +
                point.y
              );
            },
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
            layout: "horizontal",
            align: "center",
            verticalAlign: "bottom",
            itemStyle: {
              font: "7pt Trebuchet MS, Verdana, sans-serif",
            },
            symbolWidth: 7,
            symbolHeight: 7,
            symbolRadius: 2,
          },

          plotOptions: {
            series: {
              pointIntervalUnit: "month",
              compare: "value",
              showInNavigator: true,
              // stacking: 'percent'
            },
          },

          series: data.response,
        });
      }
    );
  }

  getLeadPieChart() {
    Highcharts.getJSON(
      process.env.REACT_APP_CRM +
      `/analytics/get-monthly-pie-chart?start_date=${this.state.start_year_month}&end_date=${this.state.end_year_month}&type=pie_lead`,
      function (data) {
        Highcharts.chart("lead_pie_chart", {
          chart: {
            type: "pie",
            options3d: {
              enabled: true,
              alpha: 45,
            },
            height: 250,
            // width: 500
          },
          exporting: {
            buttons: {
              contextButton: {
                enabled: false,
              },
            },
          },
          title: {
            text: data.last_updated,
            align: "center",
            verticalAlign: "bottom",
            y: 10,
            style: {
              fontSize: "12 px",
              color: "rgb(102, 102, 102)",
            },
          },
          subtitle: {
            text: "",
            align: "left",
          },

          credits: {
            enabled: false,
          },
          tooltip: {
            pointFormat: "<b>{point.percentage:.1f}% (${point.y})</b>",
          },

          plotOptions: {
            pie: {
              depth: 20,
            },
            series: {
              dataLabels: {
                format: "<b>{point.name} ({point.percentage:.1f}%)",
              },
            },
          },
          series: data.response,
        });
      }
    );
  }

  getCancelledPieChart() {
    Highcharts.getJSON(
      process.env.REACT_APP_CRM +
      `/analytics/get-monthly-pie-chart?start_date=${this.state.start_year_month}&end_date=${this.state.end_year_month}&type=pie_cancelled`,
      function (data) {
        Highcharts.chart("cancelled_pie_chart", {
          chart: {
            type: "pie",
            options3d: {
              enabled: true,
              alpha: 45,
            },
            height: 250,
            // width: 500
          },
          exporting: {
            buttons: {
              contextButton: {
                enabled: false,
              },
            },
          },
          title: {
            text: data.last_updated,
            align: "center",
            verticalAlign: "bottom",
            y: 10,
            style: {
              fontSize: "12 px",
              color: "rgb(102, 102, 102)",
            },
          },
          subtitle: {
            text: "",
            align: "left",
          },

          credits: {
            enabled: false,
          },
          tooltip: {
            pointFormat: "<b>{point.percentage:.1f}% (${point.y})</b>",
          },

          plotOptions: {
            pie: {
              depth: 20,
            },
            series: {
              dataLabels: {
                format: "<b>{point.name} ({point.percentage:.1f}%)",
              },
            },
          },
          series: data.response,
        });
      }
    );
  }

  getCustomerChart() {
    Highcharts.getJSON(
      process.env.REACT_APP_CRM +
      `/analytics/get-monthly-line-chart?start_date=${this.state.start_year_month}&end_date=${this.state.end_year_month}&type=customer`,
      function (data) {
        Highcharts.chart("customer_line_chart", {
          chart: {
            type: "line",
            height: 250,
          },
          exporting: {
            buttons: {
              contextButton: {
                enabled: false,
              },
            },
          },
          title: {
            text: " ",
            align: "left",
          },

          subtitle: {
            text: "",
            align: "left",
          },

          yAxis: {
            title: {
              text: "",
            },
            gridLineColor: "#ffffff",
            lineColor: "#ffffff",
          },

          xAxis: {
            title: {
              text: data.last_updated,
            },
            type: "datetime",
            dateTimeLabelFormats: {
              day: "%e %b", // format for days
            },
          },
          tooltip: {
            formatter: function () {
              var point = this.point;
              var series = point.series;
              var index = point.index;

              // Check if there is a previous point
              if (index > 0) {
                var prevPoint = series.data[index - 1];
                if (prevPoint.y !== 0 && Math.abs(prevPoint.y) > 0.000001) {
                  var percentageChange =
                    ((point.y - prevPoint.y) / prevPoint.y) * 100;
                  if (isFinite(percentageChange)) {
                    return (
                      // series.name +
                      // "<br>" +
                      Highcharts.dateFormat("%b", point.x) +
                      ": " +
                      point.y +
                      " (" +
                      percentageChange.toFixed(2) +
                      "%)"
                    );
                  } else {
                    return (
                      // series.name +
                      // "<br>" +
                      Highcharts.dateFormat("%b", point.x) +
                      ": " +
                      point.y +
                      " (Infinity)"
                    );
                  }
                } else if (prevPoint.y === 0) {
                  return (
                    series.name +
                    "<br>" +
                    Highcharts.dateFormat("%b", point.x) +
                    ": " +
                    point.y +
                    " (0.00%)"
                  );
                } else {
                  return (
                    series.name +
                    "<br>" +
                    Highcharts.dateFormat("%b", point.x) +
                    ": " +
                    point.y +
                    " (NaN)"
                  );
                }
              }

              // If there is no previous point, only display the value
              return (
                series.name +
                "<br>" +
                Highcharts.dateFormat("%b", point.x) +
                ": " +
                point.y
              );
            },
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
            layout: "horizontal",
            align: "center",
            verticalAlign: "bottom",
            itemStyle: {
              font: "7pt Trebuchet MS, Verdana, sans-serif",
            },
            symbolWidth: 7,
            symbolHeight: 7,
            symbolRadius: 2,
          },

          plotOptions: {
            series: {
              label: {
                connectorAllowed: false,
              },
              pointIntervalUnit: "month",
            },
          },

          series: data.response,
        });
      }
    );
  }

  getCancelledChart() {
    Highcharts.getJSON(
      process.env.REACT_APP_CRM +
      `/analytics/get-monthly-line-chart?start_date=${this.state.start_year_month}&end_date=${this.state.end_year_month}&type=cancelled`,
      function (data) {
        Highcharts.chart("cancelled_line_chart", {
          chart: {
            type: "line",
            height: 250,
          },

          exporting: {
            buttons: {
              contextButton: {
                enabled: false,
              },
            },
          },
          title: {
            text: " ",
            align: "left",
          },
          navigation: {
            buttonOptions: {
              enabled: false,
            },
          },

          subtitle: {
            text: "",
            align: "left",
          },

          yAxis: {
            title: {
              text: "",
            },
            gridLineColor: "#ffffff",
            lineColor: "#ffffff",
          },

          xAxis: {
            title: {
              text: data.last_updated,
            },
            type: "datetime",
            dateTimeLabelFormats: {
              day: "%e %b", // format for days
            },
          },
          tooltip: {
            formatter: function () {
              var point = this.point;
              var series = point.series;
              var index = point.index;

              // Check if there is a previous point
              if (index > 0) {
                var prevPoint = series.data[index - 1];
                if (prevPoint.y !== 0 && Math.abs(prevPoint.y) > 0.000001) {
                  var percentageChange =
                    ((point.y - prevPoint.y) / prevPoint.y) * 100;
                  if (isFinite(percentageChange)) {
                    return (
                      // series.name +
                      // "<br>" +
                      Highcharts.dateFormat("%b", point.x) +
                      ": <b>" +
                      point.y +
                      "</b> (" +
                      percentageChange.toFixed(2) +
                      "%)"
                    );
                  } else {
                    return (
                      // "<b>" +
                      // series.name +
                      // "</b><br>" +
                      Highcharts.dateFormat("%b", point.x) +
                      ": <b>" +
                      point.y +
                      "</b> (Infinity)"
                    );
                  }
                } else if (prevPoint.y === 0) {
                  return (
                    // "<b>" +
                    // series.name +
                    // "</b><br>" +
                    Highcharts.dateFormat("%b", point.x) +
                    ": <b>" +
                    point.y +
                    "</b> (0.00%)"
                  );
                } else {
                  return (
                    // "<b>" +
                    // series.name +
                    // "</b><br>" +
                    Highcharts.dateFormat("%b", point.x) +
                    ": <b>" +
                    point.y +
                    "</b> (NaN)"
                  );
                }
              }

              // If there is no previous point, only display the value
              return (
                // "<b>" +
                // series.name +
                // "</b><br>" +
                Highcharts.dateFormat("%b", point.x) +
                ": <b>" +
                point.y +
                "</b>"
              );
            },
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
            layout: "horizontal",
            align: "center",
            verticalAlign: "bottom",
            itemStyle: {
              font: "7pt Trebuchet MS, Verdana, sans-serif",
            },
            symbolWidth: 7,
            symbolHeight: 7,
            symbolRadius: 2,
          },

          plotOptions: {
            series: {
              pointIntervalUnit: "month",
              compare: "value",
              showInNavigator: true,
              // stacking: 'percent'
            },
          },

          series: data.response,
        });
      }
    );
  }

  getTrendFunnel() {
    Highcharts.getJSON(
      process.env.REACT_APP_CRM +
      `/analytics/get-monthly-funnel-chart?start_date=${this.state.start_year_month}&end_date=${this.state.end_year_month}`,
      function (data) {
        Highcharts.chart("traffic_chart", {
          chart: {
            type: "funnel",
            height: 250,
          },
          exporting: {
            buttons: {
              contextButton: {
                enabled: false,
              },
            },
          },
          title: {
            text: data.last_updated,
            align: "center",
            verticalAlign: "bottom",
            y: 10,
            style: {
              fontSize: "12 px",
              color: "rgb(102, 102, 102)",
            },
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                format:
                  "<b>{point.name} ({point.customValue:,.0f}, {point.percent}%)",
                softConnector: true,
              },
              center: ["40%", "50%"],
              neckWidth: "30%",
              neckHeight: "25%",
              width: "70%",
            },
          },
          tooltip: {
            enabled: true,
            formatter: function () {
              return (
                "<b>" + this.point.name + "</b><br>" + this.point.customValue
              );
            },
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            borderColor: "black",
            borderRadius: 5,
            borderWidth: 1,
            style: {
              color: "black",
            },
          },

          legend: {
            enabled: false,
          },
          series: data.response,

          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 500,
                },
                chartOptions: {
                  plotOptions: {
                    series: {
                      dataLabels: {
                        inside: true,
                      },
                      center: ["50%", "50%"],
                      width: "100%",
                    },
                  },
                },
              },
            ],
          },
          credits: {
            enabled: false,
          },
        });
      }
    );
  }

  getTrafficChart() {
    Highcharts.getJSON(
      process.env.REACT_APP_CRM +
      `/analytics/traffic-trend?start_date=${this.state.start_year_month}&end_date=${this.state.end_year_month}&cache=${this.state.traffic_cache}`,
      function (data) {
        Highcharts.chart("traffic_trend", {
          chart: {
            type: "line",
            height: 250,
          },
          exporting: {
            buttons: {
              contextButton: {
                enabled: false,
              },
            },
          },
          title: {
            text: " ",
            align: "left",
          },

          subtitle: {
            text: "",
            align: "left",
          },

          yAxis: {
            title: {
              text: "",
            },
            gridLineColor: "#ffffff",
            lineColor: "#ffffff",
          },

          xAxis: {
            title: {
              text: data.last_updated,
            },
            type: "datetime",
            dateTimeLabelFormats: {
              day: "%e %b", // format for days
            },
          },
          tooltip: {
            formatter: function () {
              var point = this.point;
              var series = point.series;
              var index = point.index;

              // Check if there is a previous point
              if (index > 0) {
                var prevPoint = series.data[index - 1];
                if (prevPoint.y !== 0 && Math.abs(prevPoint.y) > 0.000001) {
                  var percentageChange =
                    ((point.y - prevPoint.y) / prevPoint.y) * 100;
                  if (isFinite(percentageChange)) {
                    return (
                      // series.name +
                      // "<br>" +
                      Highcharts.dateFormat("%b", point.x) +
                      ": " +
                      point.y +
                      " (" +
                      percentageChange.toFixed(2) +
                      "%)"
                    );
                  } else {
                    return (
                      // series.name +
                      // "<br>" +
                      Highcharts.dateFormat("%b", point.x) +
                      ": " +
                      point.y +
                      " (Infinity)"
                    );
                  }
                } else if (prevPoint.y === 0) {
                  return (
                    // series.name +
                    // "<br>" +
                    Highcharts.dateFormat("%b", point.x) +
                    ": " +
                    point.y +
                    " (0.00%)"
                  );
                } else {
                  return (
                    // series.name +
                    // "<br>" +
                    Highcharts.dateFormat("%b", point.x) +
                    ": " +
                    point.y +
                    " (NaN)"
                  );
                }
              }

              // If there is no previous point, only display the value
              return (
                // series.name +
                // "<br>" +
                Highcharts.dateFormat("%b", point.x) +
                ": " +
                point.y
              );
            },
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
            layout: "horizontal",
            align: "center",
            verticalAlign: "bottom",
            itemStyle: {
              font: "7pt Trebuchet MS, Verdana, sans-serif",
            },
            symbolWidth: 7,
            symbolHeight: 7,
            symbolRadius: 2,
          },

          plotOptions: {
            series: {
              pointIntervalUnit: "month",
              compare: "value",
              showInNavigator: true,
              // stacking: 'percent'
            },
          },

          series: data.response,
        });
      }
    );
  }

  /** Workd map Customization Start*/
  async getCountryData() {
    const topology = await fetch("https://code.highcharts.com/mapdata/custom/world.topo.json").then((response) =>
      response.json()
    );
    let apiUrl;
    if (this.state.user_type == "activeUsers" || this.state.user_type == "newUsers") {
      apiUrl =
        process.env.REACT_APP_CRM +
        `/analytics/get-worlwide-data?start_date=${this.state.newStartDate}&end_date=${this.state.newEndDate}&type=${this.state.user_type}`;
    } else {
      apiUrl =
        process.env.REACT_APP_CRM +
        `/analytics/get-worlwide-customer-data?start_date=${this.state.newStartDate}&end_date=${this.state.newEndDate}&type=${this.state.user_type}`;
    }
    //process.env.REACT_APP_CRM +`/analytics/get-worlwide-data?start_date=${this.state.start_year_month}&end_date=${this.state.end_year_month}&type=${this.state.user_type}`
    Highcharts.getJSON(apiUrl, function (data) {
      // Create the chart
      Highcharts.mapChart("worldwide_chart", {
        chart: {
          map: topology,
          height: 250,
          mapNavigation: {
            enabled: false,
          },
        },

        exporting: {
          buttons: {
            contextButton: {
              enabled: false,
            },
          },
        },
        title: {
          text: data.last_updated,
          align: "center",
          verticalAlign: "bottom",
          y: 10,
          style: {
            fontSize: "12 px",
            color: "rgb(102, 102, 102)",
          },
        },

        subtitle: {
          text: "",
        },

        credits: {
          enabled: false,
        },

        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: "bottom",
          },
        },

        colorAxis: {
          min: 1,
          type: "logarithmic",
          minColor: "#EEEEFF",
          maxColor: "rgb(25, 103, 210)",
          stops: [
            [0, "#EFEFFF"],
            [0.67, "#4444FF"],
            [1, "#000022"],
          ],
        },
        tooltip: {
          formatter: function () {
            return this.point.name + ":" + this.point.value;
          },
        },
        series: [
          {
            data: data.response,
            states: {
              hover: {
                color: "#0063e1",
              },
            },
            dataLabels: {
              enabled: false,
              format: "{point.name}",
            },
          },
        ],
      });
    });
  }

  async getCustomerData() {
    const topology = await fetch("https://code.highcharts.com/mapdata/custom/world.topo.json").then((response) =>
      response.json()
    );
    const start_year_month = this.state.start_year_month;
    const end_year_month = this.state.end_year_month;
    Highcharts.getJSON(
      process.env.REACT_APP_CRM +
      `/analytics/get-worlwide-customer-data?start_date=${this.state.start_year_month}&end_date=${this.state.end_year_month}`,
      function (data) {
        // Create the chart
        Highcharts.mapChart("worldwide_customer_chart", {
          chart: {
            map: topology,
            height: 250,
            mapNavigation: {
              enabled: false,
            },
          },

          exporting: {
            buttons: {
              contextButton: {
                enabled: false,
              },
            },
          },
          title: {
            text: "", // data.last_updated,
            align: "center",
            verticalAlign: "bottom",
            y: 10,
            style: {
              fontSize: "12 px",
              color: "rgb(102, 102, 102)",
            },
          },

          subtitle: {
            text: "",
          },

          credits: {
            enabled: false,
          },

          mapNavigation: {
            enabled: true,
            buttonOptions: {
              verticalAlign: "bottom",
            },
          },

          colorAxis: {
            min: 1,
            type: "logarithmic",
            minColor: "#EEEEFF",
            maxColor: "rgb(25, 103, 210)",
            stops: [
              [0, "#EFEFFF"],
              [0.67, "#4444FF"],
              [1, "#000022"],
            ],
          },
          tooltip: {
            formatter: function () {
              return this.point.name + ":" + this.point.value;
            },
          },
          series: [
            {
              data: data.response,
              states: {
                hover: {
                  color: "#0CB9F2",
                },
              },
              dataLabels: {
                enabled: false,
                format: "{point.name}",
              },
              // Add a click event to each country
              point: {
                events: {
                  click: function () {
                    //console.log(this.properties["hc-a2"]);
                    //alert(`Country: ${this.name}, Value: ${this.value}`);
                    window.location.href = `/accounts/list?type=customer&country_code=${this.properties["hc-a2"]}&start_date=${start_year_month}&end_date=${end_year_month}`;
                    //window.open(`/accounts/list/?type=customer&country=${this.name}`, "_blank");
                    // You can replace the alert with any action, such as:
                    // Redirecting: window.location.href = `/details/${this.name}`;
                    // Logging details: console.log("Clicked country:", this.name);
                  },
                },
              },
            },
          ],
        });
      }
    );
  }

  /** Workd map Customization End*/

  datePickerChange(start, end) {
    this.setState({ from_date: start, to_date: end });
    this.productDashboard();
  }

  convertToDate = (rdate) => {
    let date = new Date(rdate);
    return `${date.getFullYear()}-${date.getMonth() + 1}`;
  };

  dateHandler = (date, field) => {
    this.setState(
      (state) => {
        return {
          ...state,
          [field]: date,
        };
      },
      () => {
        let startDate = this.convertToDate(this.state.startDate);
        let op_d = this.state.endDate;
        let st_d = this.state.startDate;
        let endDate = new Date(op_d.getFullYear(), op_d.getMonth() + 1, 0);

        this.setState({
          start_year_month: `${st_d.getFullYear()}-${st_d.getMonth() + 1}`,
          traffic_cache: 0,
        });
        this.setState({
          end_year_month: `${op_d.getFullYear()}-${op_d.getMonth() + 1}`,
        });

        this.setState(
          (state) => {
            return {
              ...state,
              from_date: startDate,
              to_date: endDate,
            };
          },
          () => {
            this.productDashboard();
          }
        );
      }
    );
  };

  // updateUserType = (e) => {
  //   e.preventDefault();
  //   this.setState(
  //     {
  //       user_type: e.target.value,
  //     },
  //     () => {
  //       this.getCountryData();
  //     }
  //   );
  // };

  /** Workd map Customization Start*/
  updateUserType = (value) => {
    //e.preventDefault();
    this.setState(
      {
        user_type: value,
      },
      () => {
        this.getCountryData();
      }
    );
  };
  handleApplyTime = (value) => {
    const formattedDates = value.map((date) => moment(date).format("YYYY-MM-DD"));
    let finalStartDate = formattedDates[0];
    let finalEndDate = formattedDates[1];
    this.setState(
      {
        newStartDate: finalStartDate,
        newEndDate: finalEndDate,
        newSelDate: value,
      },
      () => {
        this.getCountryData();
      }
    );

    console.log(finalStartDate, finalEndDate);
  };
  handleCleanDate = (value) => {
    this.setState(
      {
        newStartDate: this.formattedDate + "-01",
        newEndDate: this.en_date,
        newSelDate: [new Date(this.formattedDate + "-01"), this.en_date],
      },
      () => {
        this.getCountryData();
      }
    );
  };
  handleChangeDate = (value) => {
    // `value` will contain the new date range selection
    if (!value) {
      this.setState(
        {
          newStartDate: this.formattedDate + "-01",
          newEndDate: this.en_date,
          newSelDate: [new Date(this.formattedDate + "-01"), this.en_date],
        },
        () => {
          this.getCountryData();
        }
      );
    } else {
      // Perform any other actions based on the new date range value
      const formattedDates = value.map((date) => moment(date).format("YYYY-MM-DD"));
      let finalStartDate = formattedDates[0];
      let finalEndDate = formattedDates[1];
      this.setState(
        {
          newStartDate: finalStartDate,
          newEndDate: finalEndDate,
          newSelDate: value,
        },
        () => {
          this.getCountryData();
        }
      );

      console.log(finalStartDate, finalEndDate);
    }
  };
  /** Workd map Customization End*/

  updateLeadToggle = (e, val) => {
    e.preventDefault();
    this.setState(
      {
        lead_toggle: val,
      },
      () => {
        this.state.lead_toggle == "true"
          ? this.getLeadChart()
          : this.getLeadPieChart();
      }
    );
  };

  updateCustomerToggle = (e, val) => {
    e.preventDefault();
    this.setState(
      {
        customer_toggle: val,
      },
      () => {
        this.state.customer_toggle == "true"
          ? this.getCustomerChart()
          : this.getProductPieChart();
      }
    );
  };

  updateRevenueToggle = (e, val) => {
    e.preventDefault();
    this.setState(
      {
        revenue_toggle: val,
      },
      () => {
        this.state.revenue_toggle == "true"
          ? this.getRevenueChart()
          : this.getRevenuePieChart();
      }
    );
  };

  updateCancelledToggle = (e, val) => {
    e.preventDefault();
    this.setState(
      {
        canellation_toggle: val,
      },
      () => {
        this.state.canellation_toggle == "true"
          ? this.getCancelledChart()
          : this.getCancelledPieChart();
      }
    );
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={"/login"} />;
    }

    const handleCallback = (start, end) => {
      this.setState({ start, end });
      this.setState({
        from_date: this.state.start.format("YYYY-MM-DD"),
        to_date: this.state.end.format("YYYY-MM-DD"),
      });
      this.datePickerChange(
        this.state.start.format("YYYY-MM-DD"),
        this.state.end.format("YYYY-MM-DD")
      );
    };
    const label =
      this.state.start.format("MMMM D, YYYY") +
      " - " +
      this.state.end.format("MMMM D, YYYY");
    return (
      <div>
        <Header brecum_name="Analytics" brecum_page="Analytics" />
        <div className="right_col">
          <div className="intranet_body product_dash">
            <div className="top-row">
              <div className="row">
                <div className="col-xs-6 col-sm-2 col-md-2 col-lg-2">
                  <label>From</label>
                  <DatePicker
                    selected={this.state.startDate}
                    onChange={(date) => this.dateHandler(date, "startDate")}
                    dateFormat="MM/yyyy"
                    maxDate={this.state.minDate}
                    showMonthYearPicker
                  />
                </div>
                <div className="col-xs-6 col-sm-2 col-md-2 col-lg-2">
                  <label>To</label>
                  <DatePicker
                    onKeyDown={(e) => e.preventDefault()}
                    selected={this.state.endDate}
                    onChange={(date) => this.dateHandler(date, "endDate")}
                    dateFormat="MM/yyyy"
                    maxDate={this.state.minDate}
                    showMonthYearPicker
                  />
                </div>
              </div>
            </div>
            <div className="loader-new" id="loader-new"></div>

            <div className="full-analytics">
              <div className="analatics-card int-box-wrapper analytics-dashboard">
                <div className="row">
                  <div className="col-xs-12 col-sm-3">
                    <div className="int-box">
                      <div className="svg-box">
                        <div className="show-icon">
                          <div className="leftSVG">
                            {/* icon and colour change */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                              <g clip-path="url(#clip0_472_2901)">
                                <path d="M17.1 21V19C17.1 17.9391 16.6785 16.9217 15.9284 16.1716C15.1783 15.4214 14.1608 15 13.1 15H5.09998C4.03911 15 3.02169 15.4214 2.27155 16.1716C1.5214 16.9217 1.09998 17.9391 1.09998 19V21" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.09998 11C11.3091 11 13.1 9.20914 13.1 7C13.1 4.79086 11.3091 3 9.09998 3C6.89084 3 5.09998 4.79086 5.09998 7C5.09998 9.20914 6.89084 11 9.09998 11Z" fill="#006EFA" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M23.1 20.9999V18.9999C23.0993 18.1136 22.8043 17.2527 22.2613 16.5522C21.7184 15.8517 20.9581 15.3515 20.1 15.1299" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.1 3.12988C16.9604 3.35018 17.723 3.85058 18.2676 4.55219C18.8122 5.2538 19.1078 6.11671 19.1078 7.00488C19.1078 7.89305 18.8122 8.75596 18.2676 9.45757C17.723 10.1592 16.9604 10.6596 16.1 10.8799" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </g>
                              <defs>
                                <clipPath id="clip0_472_2901">
                                  <rect width="24" height="24" fill="white" transform="translate(0.0999756)" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="int-box-right statistic-card">
                        <h2>
                          {this.state.total_leads ? this.state.total_leads : 0}
                        </h2>
                        <p>Leads</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-3">
                    <div className="int-box">
                      <div className="svg-box">
                        <div className="show-icon">
                          <div className="leftSVG">
                            {/* icon and colour change */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="22" viewBox="0 0 32 22" fill="none">
                              <path d="M24.2299 19.8252V17.8252C24.2299 16.7643 23.8085 15.7469 23.0583 14.9968C22.3082 14.2466 21.2908 13.8252 20.2299 13.8252H12.2299C11.1691 13.8252 10.1516 14.2466 9.40149 14.9968C8.65135 15.7469 8.22992 16.7643 8.22992 17.8252V19.8252" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M16.2299 9.8252C18.4391 9.8252 20.2299 8.03433 20.2299 5.8252C20.2299 3.61606 18.4391 1.8252 16.2299 1.8252C14.0208 1.8252 12.2299 3.61606 12.2299 5.8252C12.2299 8.03433 14.0208 9.8252 16.2299 9.8252Z" fill="#006EFA" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M30.2299 19.8251V17.8251C30.2292 16.9388 29.9342 16.0779 29.3912 15.3774C28.8482 14.6769 28.088 14.1766 27.2299 13.9551" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M5.12295 13.9043L3.708 15.3178C3.08145 15.9446 2.68082 16.7618 2.56901 17.641C2.4572 18.5202 2.64055 19.4116 3.09027 20.1753" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M23.2299 1.95508C24.0903 2.17538 24.8529 2.67578 25.3975 3.37739C25.9421 4.079 26.2377 4.94191 26.2377 5.83008C26.2377 6.71825 25.9421 7.58116 25.3975 8.28277C24.8529 8.98438 24.0903 9.48478 23.2299 9.70508" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M8.4599 9.7251C7.60911 9.47015 6.86737 8.93929 6.35161 8.21621C5.83586 7.49313 5.57543 6.61896 5.61138 5.73151C5.64734 4.84407 5.97763 3.99384 6.55019 3.31485C7.12274 2.63586 7.905 2.16674 8.77362 1.98145" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="int-box-right statistic-card">
                        <h2>
                          {this.state.total_customers
                            ? this.state.total_customers
                            : 0}
                        </h2>
                        <p>Customers</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-3">
                    <div className="int-box">
                      <div className="svg-box">
                        <div className="show-icon">
                          <div className="leftSVG">
                            {/* icon and colour change */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                              <path d="M20.6 21V19C20.6 17.9391 20.1785 16.9217 19.4284 16.1716C18.6783 15.4214 17.6608 15 16.6 15H8.59998C7.53911 15 6.52169 15.4214 5.77155 16.1716C5.0214 16.9217 4.59998 17.9391 4.59998 19V21" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M12.6 11C14.8091 11 16.6 9.20914 16.6 7C16.6 4.79086 14.8091 3 12.6 3C10.3908 3 8.59998 4.79086 8.59998 7C8.59998 9.20914 10.3908 11 12.6 11Z" fill="#006EFA" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="int-box-right statistic-card">
                        <h2>
                          {this.state.total_cancelled
                            ? this.state.total_cancelled
                            : 0}
                        </h2>
                        <p>Cancelled</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-3">
                    <div className="int-box">
                      <div className="svg-box">
                        <div className="show-icon">
                          <div className="leftSVG">
                            {/* icon and colour change */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                              <path d="M23.1602 20.1111H22.3453V3.81481C22.3453 3.59871 22.2595 3.39146 22.1067 3.23865C21.9539 3.08585 21.7466 3 21.5305 3H15.8268C15.6107 3 15.4035 3.08585 15.2507 3.23865C15.0979 3.39146 15.012 3.59871 15.012 3.81481V7.88889H10.1231C9.90702 7.88889 9.69977 7.97474 9.54696 8.12754C9.39416 8.28035 9.30831 8.4876 9.30831 8.7037V12.7778H4.41942C4.20332 12.7778 3.99607 12.8636 3.84326 13.0164C3.69045 13.1692 3.60461 13.3765 3.60461 13.5926V20.1111H2.78979C2.57369 20.1111 2.36644 20.197 2.21363 20.3498C2.06082 20.5026 1.97498 20.7098 1.97498 20.9259C1.97498 21.142 2.06082 21.3493 2.21363 21.5021C2.36644 21.6549 2.57369 21.7407 2.78979 21.7407H23.1602C23.3763 21.7407 23.5835 21.6549 23.7363 21.5021C23.8891 21.3493 23.975 21.142 23.975 20.9259C23.975 20.7098 23.8891 20.5026 23.7363 20.3498C23.5835 20.197 23.3763 20.1111 23.1602 20.1111ZM10.9379 9.51852H15.012V20.1111H10.9379V9.51852ZM5.23424 14.4074H9.30831V20.1111H5.23424V14.4074Z" fill="#006EFA" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="int-box-right statistic-card">
                        <h2>
                          ${" "}
                          {this.state.total_revenue
                            ? this.state.total_revenue
                            : 0}
                        </h2>
                        <p>Revenue</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xs-12 col-sm-6">
                <div className="graph revenue-graph">
                  <div className="graph-top">
                    <div className="graph-title">
                      Traffic Trend
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="This shows the number of visitors visiting our Muvi website over a period of time"
                      >
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                      </span>
                    </div>
                    <div className="date-range-graph">
                      {new Date(this.state.startDate).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        }
                      )}{" "}
                      -{" "}
                      {new Date(this.state.to_date).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        }
                      )}
                    </div>
                  </div>
                  <div id="traffic_trend" className="product-graph"></div>
                </div>
              </div>

              <div className="col-xs-12 col-sm-6">
                <div className="graph revenue-graph">
                  <div className="graph-top">
                    <div className="graph-title">
                      Lead Trend{" "}
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="This shows the number of customer cancelling the product subscriptions over a period of time"
                      >
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                      </span>{" "}
                      &nbsp;
                      <div
                        class="btn-group chart-btn"
                        role="group"
                        aria-label="..."
                      >
                        <button
                          type="button"
                          class={`btn btn-xs btn-default ${this.state.lead_toggle == "true"
                            ? "active_toggle"
                            : ""
                            }`}
                          onClick={(e) => this.updateLeadToggle(e, "true")}
                          value={true}
                        >
                          <i class="fa fa-line-chart" aria-hidden="true"></i>
                        </button>

                        <button
                          type="button"
                          class={`btn btn-xs btn-default ${this.state.lead_toggle == "false"
                            ? "active_toggle"
                            : ""
                            }`}
                          onClick={(e) => this.updateLeadToggle(e, "false")}
                          value={false}
                        >
                          <i class="fa fa-pie-chart" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                    <div className="date-range-graph">
                      {new Date(this.state.startDate).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        }
                      )}{" "}
                      -{" "}
                      {new Date(this.state.to_date).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        }
                      )}
                    </div>
                  </div>
                  {this.state.lead_toggle == "true" ? (
                    <div id="lead_chart" className="product-graph"></div>
                  ) : (
                    <div id="lead_pie_chart" className="product-graph"></div>
                  )}
                </div>
              </div>

              <div className="col-xs-12 col-sm-6">
                <div className="graph revenue-graph">
                  <div className="graph-top">
                    <div className="graph-title">
                      Customer Trend
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="This shows the number of customers for all products over a period of time"
                      >
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                      </span>{" "}
                      &nbsp;
                      {/* <select onChange={this.updateCustomerToggle}>
																								<option value={true}>Line Chart</option>
																								<option value={false} >Pie Chart</option>
																						</select> */}
                      <div
                        class="btn-group chart-btn"
                        role="group"
                        aria-label="..."
                      >
                        <button
                          type="button"
                          class={`btn btn-xs btn-default ${this.state.customer_toggle == "true"
                            ? "active_toggle"
                            : ""
                            } `}
                          onClick={(e) => this.updateCustomerToggle(e, "true")}
                          value={true}
                        >
                          <i class="fa fa-line-chart" aria-hidden="true"></i>
                        </button>
                        <button
                          type="button"
                          class={`btn btn-xs btn-default ${this.state.customer_toggle == "false"
                            ? "active_toggle"
                            : ""
                            } `}
                          onClick={(e) => this.updateCustomerToggle(e, "false")}
                          value={false}
                        >
                          <i class="fa fa-pie-chart" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                    <div className="date-range-graph">
                      {new Date(this.state.startDate).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        }
                      )}{" "}
                      -{" "}
                      {new Date(this.state.to_date).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        }
                      )}
                    </div>
                  </div>
                  {this.state.customer_toggle == "true" ? (
                    <div
                      id="customer_line_chart"
                      className="product-graph"
                    ></div>
                  ) : (
                    <div id="product_pie_chart" className="product-graph"></div>
                  )}
                </div>
              </div>

              <div className="col-xs-12 col-sm-6">
                <div className="graph revenue-graph">
                  <div className="graph-top">
                    <div className="graph-title">
                      Revenue Trend
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="This shows the amount of revenue products are generating over a period of time"
                      >
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                      </span>{" "}
                      &nbsp;
                      {/* <select onChange={this.updateRevenueToggle}>
																								<option value={true}>Line Chart</option>
																								<option value={false} >Pie Chart</option>
																						</select> */}
                      <div
                        class="btn-group chart-btn"
                        role="group"
                        aria-label="..."
                      >
                        <button
                          type="button"
                          class={`btn btn-xs btn-default ${this.state.revenue_toggle == "true"
                            ? "active_toggle"
                            : ""
                            } `}
                          onClick={(e) => this.updateRevenueToggle(e, "true")}
                          value={true}
                        >
                          <i class="fa fa-line-chart" aria-hidden="true"></i>
                        </button>
                        <button
                          type="button"
                          class={`btn btn-xs btn-default ${this.state.revenue_toggle == "false"
                            ? "active_toggle"
                            : ""
                            } `}
                          onClick={(e) => this.updateRevenueToggle(e, "false")}
                          value={false}
                        >
                          <i class="fa fa-pie-chart" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                    <div className="date-range-graph">
                      {new Date(this.state.startDate).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        }
                      )}{" "}
                      -{" "}
                      {new Date(this.state.to_date).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        }
                      )}
                    </div>
                  </div>
                  {this.state.revenue_toggle == "true" ? (
                    <div
                      id="revenue_base_chart"
                      className="product-graph"
                    ></div>
                  ) : (
                    <div id="revenue_pie_chart" className="product-graph"></div>
                  )}
                </div>
              </div>

              <div className="col-xs-12 col-sm-6">
                <div className="graph revenue-graph">
                  <div className="graph-top">
                    <div className="graph-title">
                      Cancellation Trend
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="This shows the number of customer cancelling the product subscriptions over a period of time"
                      >
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                      </span>{" "}
                      &nbsp;
                      {/* <select onChange={this.updateCancelledToggle}>
																								<option value={true}>Line Chart</option>
																								<option value={false} >Pie Chart</option>
																						</select> */}
                      <div
                        class="btn-group chart-btn"
                        role="group"
                        aria-label="..."
                      >
                        <button
                          type="button"
                          class={`btn btn-xs btn-default ${this.state.canellation_toggle == "true"
                            ? "active_toggle"
                            : ""
                            } `}
                          onClick={(e) => this.updateCancelledToggle(e, "true")}
                          value={true}
                        >
                          <i class="fa fa-line-chart" aria-hidden="true"></i>
                        </button>
                        <button
                          type="button"
                          class={`btn btn-xs btn-default ${this.state.canellation_toggle == "false"
                            ? "active_toggle"
                            : ""
                            } `}
                          onClick={(e) =>
                            this.updateCancelledToggle(e, "false")
                          }
                          value={false}
                        >
                          <i class="fa fa-pie-chart" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                    <div className="date-range-graph">
                      {new Date(this.state.startDate).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        }
                      )}{" "}
                      -{" "}
                      {new Date(this.state.to_date).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        }
                      )}
                    </div>
                  </div>
                  {this.state.canellation_toggle == "true" ? (
                    <div
                      id="cancelled_line_chart"
                      className="product-graph"
                    ></div>
                  ) : (
                    <div
                      id="cancelled_pie_chart"
                      className="product-graph"
                    ></div>
                  )}
                </div>
              </div>

              <div className="col-xs-12 col-sm-6">
                <div className="graph revenue-graph">
                  <div className="graph-top">
                    <div className="graph-title">Sales Funnel</div>
                    <div className="date-range-graph">
                      {new Date(this.state.startDate).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        }
                      )}{" "}
                      -{" "}
                      {new Date(this.state.to_date).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        }
                      )}
                    </div>
                  </div>
                  <div id="traffic_chart" className="product-graph"></div>
                </div>
              </div>

              <div className="col-xs-12 col-sm-6">
                <div className="graph revenue-graph">
                  <div className="graph-top">
                    <div className="graph-title">
                      World Map &nbsp;
                      {/* <select onChange={this.updateUserType}>
                                                <option value="activeUsers">Visitors</option>
                                                <option value="newUsers" >New Visitors</option>
                                            </select> */}
                    </div>
                    <div className="date-range-graph" style={{ display: "flex" }}>
                      <SelectPicker
                        data={dealStates}
                        name="deal_state"
                        className="deal-state"
                        value={this.state.user_type}
                        onChange={this.updateUserType}
                        style={{
                          width: "80%",
                          zIndex: 1050,
                        }}
                        block={true}
                        searchable={false}
                        placeholder="Select Type"
                      />
                      &nbsp;&nbsp;&nbsp;
                      <DateRangePicker
                        showOneCalendar
                        ranges={predefinedRanges}
                        onOk={this.handleApplyTime}
                        onClean={this.handleCleanDate}
                        onChange={this.handleChangeDate}
                        value={this.state.newSelDate}
                        block={true}
                        style={{
                          width: "100%",
                          zIndex: 1050,
                        }}
                      />
                      {/* {new Date(this.state.startDate).toLocaleDateString("en-US", {
												month: "short",
												day: "numeric",
												year: "numeric",
											})}{" "}
											-{" "}
											{new Date(this.state.to_date).toLocaleDateString("en-US", {
												month: "short",
												day: "numeric",
												year: "numeric",
											})} */}
                    </div>
                  </div>
                  <div id="worldwide_chart" className="product-graph"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Newanalytics;

// WEBPACK FOOTER //
// ./src/components/analytics/Newanalytics.js



// WEBPACK FOOTER //
// ./src/components/analytics/Newanalytics.js